<div app-landing-page-section-container class="items-center pt-5 lg:pt-10">
    <div class="mat-headline-6 lg:w-[900px] text-center pb-4" translate>
        LandingPageQuotes
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:px-8 mt-4 md:mt-8">
        <div class="quote-box-rounded">
            <div class="author-box">
                <img
                    class="w-10"
                    src="/assets/images/landing-page/quotes/logo-randli-agrar.png"
                    alt="Randli Agrar"
                />

                <div class="author-text">Levente Szőr</div>
                <div class="mat-body-1 m-0">Rail Operation Manager</div>
            </div>

            <div class="m-auto">
                <translate class="mat-body-1 m-0">RandliAgrarQuote</translate>
            </div>
        </div>
        <div class="quote-box-rounded">
            <div class="author-box">
                <img
                    class="w-20 h-12"
                    src="/assets/images/landing-page/quotes/logo-rail-care-logo.svg"
                    alt="Railcare"
                />
                <div class="author-text">Marco Berti</div>
                <div class="mat-body-1 m-0">Head of Fleet Management</div>
            </div>

            <div class="m-auto">
                <translate class="mat-body-1 m-0">RailCareQuote</translate>
            </div>
        </div>
    </div>
</div>
